import { Component, OnInit, Input } from '@angular/core';
import { ExibeErro } from './ExibeErro';

@Component({
  selector: 'app-exibe-erros',
  templateUrl: './exibe-erros.component.html'
})
export class ExibeErrosComponent {

  @Input() erros: Array<ExibeErro>;
  @Input() serverErros: string[];
  constructor() { }

  exibirErro() {

    if (this.serverErros && this.serverErros.length) {
      return true;
    }

    if (this.erros) {
      for (const erro of this.erros) {
        if (erro.exibir) {
          return true;
        }
      }
    }
    return false;
  }
}
